'use strict';

import { Modal, Button, ButtonSet, Alert } from '@ux/uxcore2';
import React from 'react';


export default class VaultDialog extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      loaded: false,
      alertDisplay: 'none',
      alertStatus: 'success',
      alertHeader: '',
      alertMessage: ''
    };
  }

  setAlertState(display, status, header, message) {
    this.setState({
      alertDisplay: display,
      alertStatus: status,
      alertHeader: header,
      alertMessage: message
    });
  }

  loadDialogContent() {
    var dialogContent = $(this.props.contentSelector);
    dialogContent.appendTo('.modal-body');
    this.props.initFunction();
    this.state.loaded = true;
  }

  storeDialogContent() {
    var dialogContent = $(this.props.contentSelector);
    dialogContent.appendTo('#vault-dialogs');
    this.state.loaded = false;
  }

  componentDidUpdate() {
    if (this.state.modal && !this.state.loaded) {
      this.loadDialogContent();
    }
  }

  doContinueFunc() {
    var self = this;
    this.props.continueFunction(function(err, { status, header, message }) {
      if (err) {
        self.setAlertState('block', status, header, message);
      }
      else {
        self.setAlertState('block', status, header, message);
      }
    });
  }

  closeModal() {
    this.storeDialogContent();
    this.setState({ modal: false });
    this.setAlertState('none', 'success', '', '');
  }

  modal() {
    if (!this.state.modal) {
      return null;
    }

    const footer = (
      <ButtonSet>
        <Button design='primary' onClick={ () => { this.doContinueFunc(); }}>
          {this.props.continueButtonLabel}
        </Button>
        <Button design='default' onClick={ () => { this.closeModal(); }}>
          {this.props.closeButtonLabel}
        </Button>
      </ButtonSet>
    );

    return (
      <Modal
        title={this.props.title}
        onClose={ () => { this.closeModal(); }}
        footer={ footer }
      >
        <div id='dialogAlerts' style={{display: this.state.alertDisplay }}>
          <Alert id='dialogAlert' dismissible={ false } icon={this.state.alertStatus}
            header={this.state.alertHeader} message={this.state.alertMessage} />
        </div>

      </Modal>
    );
  }

  render() {
    return (
      <div>
        <Button design='primary' onClick={ () => { this.setState({ modal: true }); }}>
          {this.props.openButtonLabel}
        </Button>
        { this.modal() }
      </div>
    );
  }
}
